export default "__VITE_ASSET__BSXavJI9__"